import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'course-session-schedule'
const initialState = {
  list: null,
  recordLoading: false,
}

export const getSchedules = createApiAction(
  'scheduling/course-session-schedule/search',
  client.search('/api/scheduling/course-session-schedule/:courseSessionId'),
)
export const setSchedules = createApiAction(
  'scheduling/course-session-schedule/save',
  client.create('/api/scheduling/course-session-schedule/:courseSessionId'),
)

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    reset: state => {
      state.list = null
    },
  },
  extraReducers(builder) {
    builder.addCase(getSchedules.pending, state => {
      state.recordLoading = true
    })
    builder.addCase(getSchedules.fulfilled, (state, action) => {
      state.recordLoading = false
      state.list = action.payload
    })
  },
})

export const { reset } = sessionSlice.actions
export default sessionSlice.reducer
